<div class="filter-btn" *ngIf="isDesktopView" [ngClass]="{'filter-btn-active': filterPopup}" (click)="openFilter()">
    <span class="material-icons" style="font-size: 20px; margin-right: 10px;">filter_alt</span>
    <span>Filters</span>
    <span class="material-icons arrow-rotate" [ngClass]="filterPopup ? 'arrow-rotate-true' : 'arrow-rotate-false'">
        keyboard_arrow_down
    </span>
</div>
<div *ngIf="!isDesktopView" [ngClass]="{'filter-mobile-btn-active': filterPopup}" (click)="openFilter()">
    <span class="material-icons" style="font-size: 30px; margin-right: 10px;">filter_alt</span>
</div>
<div [ngClass]="!isDesktopView ? 'modal' : 'dialog-container'" *ngIf="filterPopup">
    <div class="dialog-content"  [ngStyle]="!isDesktopView ? {'height': '100vh', 'width': '100%','border-radius':'0px'} : {}">
        <div class="dialog-body">
            <div class="filter-list-container" [ngStyle]="!isDesktopView ? {'height': 'calc(100vh - 100px)'} : {}">
                <ul class="filter-list">
                    <span *ngFor="let item of columnList">
                        <li *ngIf="item.filterList" (click)="addFiltered(item)"
                            [class.active]="activeNavButton === item.header">
                            {{ item.header }}
                            <span class="dot-selected-filter"
                                *ngIf="selectedFields && selectedFields[item.header]?.length > 0">
                                {{ selectedFields[item.header]?.length }}
                            </span>
                        </li>
                    </span>
                </ul>
            </div>

            <div class="filter-details-container" >
                <div *ngFor="let col of columnList">
                    <div *ngIf="col.selectedFilter">
                        <div *ngIf="col?.fieldType === 'date'">
                            <div>{{col.header}}</div>
                            <div style="margin-top: 22px;">
                                <div class="form-group">
                                    <div class="input-container">
                                        <input [type]="'date'" id="start-date"
                                            [(ngModel)]="dateRange[activeDateField].start" class="input-field"
                                            (focus)="onStartDateFocus()" (blur)="onStartDateBlur()">
                                        <label [class.active]="startDateFocused || dateRange[activeDateField]?.start"
                                            for="start-date">From Date</label>
                                        <span [class.calendar-icon]="!startDateFocused"
                                            (click)="openDatePicker('start-date')"></span>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <div class="input-container">
                                        <input [type]="'date'" id="end-date"
                                            [(ngModel)]="dateRange[activeDateField].end" class="input-field"
                                            (focus)="onEndDateFocus()" (blur)="onEndDateBlur()">
                                        <label [class.active]="endDateFocused || dateRange[activeDateField]?.end"
                                            for="end-date">To Date</label>
                                        <span [class.calendar-icon]="!endDateFocused"
                                            (click)="openDatePicker('end-date')"></span>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div *ngIf="col?.fieldType !== 'date'">
                            <div class="searchBar" style="position: relative;">
                                <span class="material-icons search-icon">search</span>
                                <input type="text" [(ngModel)]="search" placeholder="Search By {{ col.header}}"
                                    class="search-input" />
                            </div>

                            <div class="filtered-list-container" [ngStyle]="!isDesktopView ? {'height': 'calc(100vh - 190px)'} : {}">
                                <div class="select-all-container">
                                    <label for="select_all_checkbox">Select all ({{ col.filterList.length
                                        }})</label>
                                    <input type="checkbox" id="select_all_checkbox"
                                        (change)="selectAllClicked(col,  $event)" />
                                </div>

                                <div *ngFor="let item of col.selectedFilterList let index = index">
                                    <div style="display: flex; justify-content: space-between;"
                                        class="filter-item-container"
                                        *ngIf="!this.search || item.item.toLowerCase().includes(this.search.toLowerCase())">
                                        <label style="width: 80%;" [for]="'id' + index">{{ item.item }}</label>
                                        <input type="checkbox" [id]="'id' + index" [(ngModel)]="item.checked" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="dialog-footer">
            <span>{{ filterCount() }} filter applied</span>
            <div style="color: #1d88fb; cursor: pointer;" (click)="clearAllFilter()">Clear all</div>
            <div style="color: #1d88fb; cursor: pointer;" (click)="applyFilter()">Apply</div>
        </div>
    </div>
</div>